import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Layout from '../components/Layout'
import { Button, Container } from '@mui/material'
import { roleListId, roleType } from '../config/roleList'
import { checkUserRole } from '../common/checkUserRole'
import BasicModal from '../components/modal/BasicModal'
import AddNew from '../components/itemCategory/AddNew'
import { getAllItemCategory } from '../store/actions/itemCategoryAction'
import ItemCategoryList from '../components/itemCategory/ItemCategoryList'

const ItemCategory = () => {
    const dispatch = useDispatch()
    const { itemCategories } = useSelector((state) => state.itemCategory)
    const { userInfo } = useSelector((state) => state.auth)
    const { roleList } = useSelector((state) => state.user)
    const [open, setOpen] = useState(false)

    useEffect(() => {
        dispatch(getAllItemCategory())
    }, [dispatch])

    return (
        <Layout>
            <Container>
                <BasicModal open={open} setOpen={setOpen}>
                    <AddNew setOpen={setOpen} />
                </BasicModal>

                <Button
                    color="info"
                    variant="outlined"
                    style={{ marginBottom: '20px' }}
                    onClick={() =>
                        checkUserRole(
                            userInfo,
                            roleList,
                            roleListId.ITEM,
                            roleType.CREATE
                        )
                            ? setOpen(true)
                            : alert('Not Permit User')
                    }
                >
                    Add New Item Category
                </Button>
                {itemCategories?.map((item) => (
                    <ItemCategoryList key={item.id} itemCategory={item} />
                ))}
            </Container>
        </Layout>
    )
}

export default ItemCategory
